
(async function(){
  var FREE = 120, MAX = 10, busy = false;
  var routeRoot = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var product;
  try {
    var response = await fetch(routeRoot + 'products/toyo-steel-stackable-storage-box-t-152.js', {cache:'no-store'});
    if (!response.ok) throw new Error('Product unavailable');
    product = await response.json();
    if (!Array.isArray(product.variants) || !product.variants.length) throw new Error('Missing variants');
  } catch(error) {
    document.getElementById('stockLbl').textContent = 'Availability unavailable';
    document.getElementById('count').innerHTML = 'We could not load current stock. <a href="' + routeRoot + 'products/toyo-steel-stackable-storage-box-t-152">Shop the T-152</a> or refresh to try again.';
    document.getElementById('shake').disabled = true;
    return;
  }
  var COLORS = [
    {id:'orange', en:'Orange', ja:'オレンジ', c:'#F07A22', stock:false},
    {id:'yellow', en:'Yellow', ja:'イエロー', c:'#F5C518', stock:true},
    {id:'glacier', en:'Glacier', ja:'グレイシャー', c:'#BFD9DA', stock:true},
    {id:'black', en:'Black', ja:'ブラック', c:'#26272A', stock:false, dark:true},
    {id:'indigo', en:'Indigo', ja:'インディゴ', c:'#2B3A67', stock:false, dark:true},
    {id:'blue', en:'Blue', ja:'ブルー', c:'#2F6DB5', stock:false, dark:true},
    {id:'green', en:'Military Green', ja:'ミリタリーグリーン', c:'#5B6443', stock:false, dark:true},
    {id:'pink', en:'Shocking Pink', ja:'ショッキングピンク', c:'#EC4A8C', stock:true},
    {id:'lilac', en:'Lilac', ja:'ライラック', c:'#B8A6D6', stock:true}
  ];
  var palette = COLORS;
  COLORS = product.variants.map(function(v){
    var col = Object.assign({}, palette.find(function(c){return c.en.toLowerCase() === v.title.toLowerCase();}) || {id:String(v.id),ja:'',c:'#BFC3C7'});
    col.en = v.title; col.variantId = v.id; col.stock = v.available; col.price = v.price / 100;
    return col;
  });
  var PRICE = Math.min.apply(null, COLORS.map(function(c){return c.price;}));
  var byId = {}; COLORS.forEach(function(c){ byId[c.id] = c; });
  var stack = ['yellow','glacier','pink'].filter(function(id){return byId[id] && byId[id].stock;});
  var $ = function(id){ return document.getElementById(id); };
  var money = function(n){ return new Intl.NumberFormat('en-US',{style:'currency',currency:product.currency || window.Shopify && Shopify.currency && Shopify.currency.active || 'USD',maximumFractionDigits:2}).format(n); };
  // whole-dollar amounts drop the cents on the price tag and ruler, where space is tight
  var moneyShort = function(n){ return new Intl.NumberFormat('en-US',{style:'currency',currency:product.currency || window.Shopify && Shopify.currency && Shopify.currency.active || 'USD',minimumFractionDigits:n % 1 ? 2 : 0,maximumFractionDigits:2}).format(n); };
  $('priceRange').textContent = moneyShort(PRICE);
  $('stockLbl').textContent = COLORS.filter(function(c){return c.stock;}).length + ' of ' + COLORS.length + ' in stock';
  $('stockFact').textContent = COLORS.filter(function(c){return c.stock;}).length + ' colors currently available.';
  var root = document.documentElement;

  // swatch card: in-stock tiles + compact sold-out row
  var tiles = $('tiles'), outs = $('outs'), qEls = {};
  COLORS.forEach(function(col){
    var b = document.createElement('button');
    b.type = 'button';
    b.style.setProperty('--c', col.c);
    if (col.stock){
      b.className = 'tile' + (col.dark ? ' dark' : '');
      b.setAttribute('aria-label', 'Add ' + col.en + ' to your stack');
      b.innerHTML = '<span class="face"></span><span class="tn"><span class="nm"><b>' + col.en + '</b><span class="ja">' + col.ja + '</span><span class="price">' + money(col.price) + '</span></span><span class="q" aria-hidden="true">+</span></span>';
      b.addEventListener('click', function(){ add(col.id); });
      qEls[col.id] = b.querySelector('.q');
      tiles.appendChild(b);
    } else {
      b.className = 'oc';
      b.title = col.en + ' · sold out';
      b.setAttribute('aria-label', col.en + ', sold out. Get a restock email');
      b.setAttribute('aria-pressed', 'false');
      b.addEventListener('click', function(){
        outs.querySelectorAll('.oc').forEach(function(o){ o.setAttribute('aria-pressed', 'false'); });
        b.setAttribute('aria-pressed', 'true');
        notify(col);
      });
      outs.appendChild(b);
    }
  });

  // ruler ticks: one per box up to 5
  var ruler = $('ruler'), SCALE = PRICE * 5;
  for (var i = 1; i <= 5; i++){
    var t = document.createElement('span'); t.className = 'tick';
    t.style.left = (i * PRICE / SCALE * 100) + '%';
    t.innerHTML = '<span>' + moneyShort(i * PRICE) + '</span>';
    if (i === 5){ t.style.left = 'calc(100% - 2px)'; t.firstChild.style.transform = 'translateX(-100%)'; t.firstChild.style.left = '2px'; }
    ruler.appendChild(t);
  }
  var g = document.createElement('span'); g.className = 'goal';
  g.style.left = (FREE / SCALE * 100) + '%';
  g.innerHTML = '<span>送料無料 FREE SHIP</span>';
  ruler.appendChild(g);

  function setPick(id){
    var col = byId[id] || COLORS.find(function(c){return c.stock;}) || COLORS[0];
    root.style.setProperty('--pick', col.c);
    var box = $('doneBox'); if (box) box.style.setProperty('--c', col.c);
  }

  function render(dropLast){
    var ul = $('stack'); ul.innerHTML = '';
    stack.forEach(function(id, i){
      var col = byId[id];
      var li = document.createElement('li');
      li.className = 'bx' + (col.dark ? ' dark' : '') + (dropLast && i === stack.length - 1 ? ' drop' : '');
      li.style.setProperty('--c', col.c);
      li.tabIndex = 0;
      li.setAttribute('role', 'button');
      li.setAttribute('aria-label', 'Remove ' + col.en + ' box');
      li.innerHTML = '<span class="x">Remove</span>';
      li.addEventListener('click', function(){ remove(i); });
      li.addEventListener('keydown', function(e){ if (e.key === 'Enter' || e.key === ' '){ e.preventDefault(); remove(i); } });
      ul.appendChild(li);
    });

    Object.keys(qEls).forEach(function(id){
      var c = stack.filter(function(s){ return s === id; }).length;
      qEls[id].textContent = c ? '×' + c : '+';
      qEls[id].classList.toggle('on', c > 0);
    });
    var empty = $('stage').querySelector('.empty');
    if (!stack.length && !empty){ empty = document.createElement('p'); empty.className = 'empty'; empty.textContent = 'Nothing here yet. Tap a color →'; $('stage').appendChild(empty); }
    if (stack.length && empty) empty.remove();

    var n = stack.length, total = stack.reduce(function(sum,id){return sum + byId[id].price;},0), left = FREE - total;
    $('count').innerHTML = n ? '<strong>' + n + '</strong>' + (n === 1 ? 'box' : 'boxes') + ' · ' + money(total) : '<strong>0</strong>Your stack is empty. Pick a color.';
    $('fill').style.width = Math.min(100, total / SCALE * 100) + '%';
    $('shipMsg').innerHTML = !n ? '' : left > 0
      ? money(left) + ' to free U.S. shipping on this stack.'
      : '<b>Free U.S. shipping unlocked.</b> 送料無料 — nicely stacked.';
    var label = n ? 'Add ' + n + ' to cart — ' + money(total) : 'Add to cart';
    ['addCart','addCart2','addCart3'].forEach(function(b){ $(b).textContent = label; $(b).disabled = !n || busy; });
    $('finalTxt').textContent = n
      ? 'You’ve built a ' + n + '-box stack for ' + money(total) + '. ' + (left > 0 ? money(left) + ' to free U.S. shipping.' : 'U.S. shipping’s on us.')
      : 'Head back up and pick a color or two.';
    var mini = $('mini'), dots = $('dots'); mini.innerHTML = ''; dots.innerHTML = '';
    stack.forEach(function(id){
      var a = document.createElement('i'); a.style.setProperty('--c', byId[id].c); mini.appendChild(a);
      var d = document.createElement('i'); d.style.setProperty('--c', byId[id].c); dots.appendChild(d);
    });
    $('barSum').textContent = n + (n === 1 ? ' box · ' : ' boxes · ') + money(total);
    setPick(stack[n - 1]);
  }

  var SFX = ['ガシャン!','ガチャ!','カン!','ドン!'];
  function add(id){
    if (busy || !byId[id] || !byId[id].stock) return;
    if (stack.length >= MAX){ toast('Ten is a lot of boxes. Check out, then build another stack.'); return; }
    stack.push(id); render(true);
    var ul = $('stack'); ul.classList.remove('jolt'); void ul.offsetWidth; ul.classList.add('jolt');
    var stage = $('stage'), top = ul.lastElementChild;
    var k = document.createElement('span'); k.className = 'kaboom';
    k.textContent = SFX[Math.floor(Math.random() * SFX.length)];
    var sr = stage.getBoundingClientRect(), tr = top.getBoundingClientRect();
    var right = tr.right - sr.left + 10;
    k.style.top = Math.max(8, tr.top - sr.top - 24) + 'px';
    if (right + 150 < sr.width) k.style.left = right + 'px'; else k.style.left = Math.max(8, tr.left - sr.left - 150) + 'px';
    setTimeout(function(){ stage.appendChild(k); setTimeout(function(){ k.remove(); }, 950); }, 280);
  }
  function remove(i){ if (busy) return; stack.splice(i, 1); render(false); }

  // On desktop the restock form opens over the control panel so the workbench keeps its height.
  // Below the workbench breakpoint it stays inline and we scroll to it.
  var ctl = $('restock').closest('.ctl'), lastOut = null;
  var overlay = function(){ return !!(window.matchMedia && window.matchMedia('(min-width: 981px)').matches); };
  function closeRestock(){
    if (!ctl.classList.contains('restock-open')) return;
    ctl.classList.remove('restock-open');
    if (lastOut) lastOut.focus({preventScroll:true});
  }
  function notify(col){
    document.dispatchEvent(new CustomEvent('rarely:demand:variant-change', {detail:{productId:String(product.id),variantId:String(col.variantId)}}));
    lastOut = document.activeElement && document.activeElement.classList.contains('oc') ? document.activeElement : null;
    if (overlay()){
      ctl.classList.add('restock-open');
      var field = $('notify').querySelector('input[type="email"]') || $('restockBack');
      field.focus({preventScroll:true});
      return;
    }
    $('notify').scrollIntoView({behavior:'smooth',block:'center'});
    toast(col.en + ' is sold out. Use the restock form below.');
  }
  $('restockBack').addEventListener('click', closeRestock);
  ctl.addEventListener('keydown', function(e){ if (e.key === 'Escape') closeRestock(); });

  // omikuji
  var FORTUNES = {
    yellow: {rank:'大吉', no:'Great blessing', text:'Good luck is coming, and so is that thing you lost in 2019. When it turns up, put it in a box.', lucky:'Lucky item: the good pencil'},
    glacier:{rank:'中吉', no:'Middle blessing', text:'Calm waters ahead. Your cables will untangle themselves, provided you stop throwing them in a drawer.', lucky:'Lucky item: a short USB-C cable'},
    pink:   {rank:'大吉', no:'Great blessing', text:'Bold choices pay off this season. So does a sewing kit you can actually find.', lucky:'Lucky item: the spare button from your coat'},
    lilac:  {rank:'吉',   no:'Blessing', text:'A quiet desk brings a quiet mind. Start small. Start with one box.', lucky:'Lucky item: a paper clip, bent back straight'}
  };
  var inStock = COLORS.filter(function(c){ return c.stock; });
  var current = inStock.length ? inStock[0].id : null;
  function showSlip(id, fresh){
    var f = FORTUNES[id] || FORTUNES.lilac, col = byId[id], slip = $('slip');
    slip.className = 'slip' + (fresh ? ' fresh' : '');
    var num = ['一','二','三','四','五','六','七','八','九'][COLORS.indexOf(col)];
    slip.innerHTML = '<span class="rank">' + f.rank + '</span><div>' +
      '<span class="no">No. ' + num + ' · ' + f.no + '</span>' +
      '<div class="col" style="--c:' + col.c + '"><span class="sw"></span><div><b>' + col.en + '</b><span class="ja">' + col.ja + '</span></div></div>' +
      '<p class="fortune">' + f.text + '</p><p class="lucky">' + f.lucky + '</p>' +
      '<button class="btn" id="slipAdd">Add ' + col.en + ' to my stack</button></div>';
    $('slipAdd').addEventListener('click', function(){ add(id); toast(col.en + ' added. Scroll up to see your stack.'); });
    $('stickNo').textContent = '第' + num + '番';
  }
  $('shake').addEventListener('click', function(){
    var opts = inStock.filter(function(c){ return c.id !== current; });
    if (!opts.length) opts = inStock;
    if (!opts.length) return;
    current = opts[Math.floor(Math.random() * opts.length)].id;
    var s = $('shrine'); s.classList.remove('shake','drawn'); void s.offsetWidth; s.classList.add('shake','drawn');
    $('slip').style.opacity = 0;
    showSlip(current, true);
    $('slip').style.opacity = '';
  });
  if (current) showSlip(current, false);
  else { $('shake').disabled = true; $('slip').textContent = 'Every color is currently sold out. Join the restock list above.'; }

  // press panel animates while visible
  var impact = $('impact');
  if ('IntersectionObserver' in window){
    new IntersectionObserver(function(es){ es.forEach(function(e){ impact.classList.toggle('go', e.isIntersecting); }); }, {threshold:.3}).observe(impact);
    var bar = $('bar'), heroSeen = true, finalSeen = false;
    var upd = function(){ var show = !heroSeen && !finalSeen && stack.length > 0; bar.classList.toggle('show', show); bar.setAttribute('aria-hidden', !show); $('addCart3').tabIndex = show ? 0 : -1; };
    new IntersectionObserver(function(es){ heroSeen = es[0].isIntersecting; upd(); }, {threshold:0}).observe($('addCart'));
    new IntersectionObserver(function(es){ finalSeen = es[0].isIntersecting; upd(); }, {threshold:0}).observe($('final'));
  }

  var tt;
  function toast(msg){ var t = $('toast'); t.textContent = msg; t.classList.add('show'); clearTimeout(tt); tt = setTimeout(function(){ t.classList.remove('show'); }, 2600); }
  ['addCart','addCart2','addCart3'].forEach(function(b){
    $(b).addEventListener('click', async function(){
      if (busy || !stack.length) return;
      busy = true; render(false);
      ['addCart','addCart2','addCart3'].forEach(function(id){$(id).textContent = 'Adding your stack…';});
      try {
        var freshResponse = await fetch(routeRoot + 'products/toyo-steel-stackable-storage-box-t-152.js', {cache:'no-store'});
        if (!freshResponse.ok) throw new Error('Could not verify stock. Please try again.');
        var fresh = await freshResponse.json();
        var quantities = {};
        stack.forEach(function(id){
          var col = byId[id], v = fresh.variants.find(function(v){return v.id === col.variantId;});
          if (!v || !v.available) throw new Error(col.en + ' has sold out. Refresh to update your stack.');
          if (v.price !== Math.round(col.price * 100)) throw new Error('Prices have changed. Refresh to update your stack.');
          quantities[col.variantId] = (quantities[col.variantId] || 0) + 1;
        });
        var result = await fetch(routeRoot + 'cart/add.js', {method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:Object.keys(quantities).map(function(id){return {id:Number(id),quantity:quantities[id]};})})});
        var data = await result.json();
        if (!result.ok) throw new Error(data.description || data.message || 'Could not add your stack. Check your cart before retrying.');
        window.location.assign(routeRoot + 'cart');
      } catch(error) {
        toast(error.message || 'Connection interrupted. Check your cart before retrying.');
        $('shipMsg').textContent = error.message || 'Connection interrupted. Check your cart before retrying.';
        busy = false;
        ['addCart','addCart2','addCart3'].forEach(function(id){$(id).disabled = !stack.length; $(id).textContent = 'Try adding your stack';});
      }
    });
  });

  render(false);
})();
